import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=ba86f128&scoped=true&"
import script from "./ReportPage.vue?vue&type=script&lang=ts&"
export * from "./ReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba86f128",
  null
  
)

export default component.exports